import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a391df4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-expect-dialog" }
const _hoisted_2 = { class: "info-card" }
const _hoisted_3 = { class: "info-card-grid" }
const _hoisted_4 = { class: "info-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "日期", -1))
const _hoisted_6 = { class: "info-value" }
const _hoisted_7 = { class: "info-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户编码", -1))
const _hoisted_9 = { class: "info-value" }
const _hoisted_10 = { class: "info-item info-item-span2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户名称", -1))
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "info-card-grid" }
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "应收账款合计", -1))
const _hoisted_16 = { class: "info-value" }
const _hoisted_17 = { class: "info-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "信用期内", -1))
const _hoisted_19 = { class: "info-value" }
const _hoisted_20 = { class: "info-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "逾期金额", -1))
const _hoisted_22 = { class: "info-value" }
const _hoisted_23 = { class: "info-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "月末到期金额", -1))
const _hoisted_25 = { class: "info-value" }

import { reactive, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import type { FormInstance, Rule } from 'ant-design-vue/es/form';
import type { ReceivableForecastItem } from './index';
import { saveExpectOverdueAmount } from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditExpectAmountDialog',
  props: {
    visible: { type: Boolean },
    record: null
  },
  emits: ["update:visible", "submitted"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
  (e: 'submitted'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
  record: ReceivableForecastItem | null;
}





const formRef = ref<FormInstance>();
const submitting = ref(false);
const form = reactive<{ expectOverdueAmount?: number }>({
  expectOverdueAmount: undefined,
});

const formRules: Record<string, Rule[]> = {
  expectOverdueAmount: [{ required: true, message: '请输入预计逾期金额', type: 'number' }],
};

function displayAmount(value?: string) {
  if (value == null || value === '' || value === '-') return '-';
  return value;
}

function parseAmount(value?: string): number | undefined {
  if (value == null || value === '' || value === '-') return undefined;
  const n = Number(value);
  return Number.isFinite(n) ? n : undefined;
}

watch(
  () => props.visible,
  (open) => {
    if (!open) {
      form.expectOverdueAmount = undefined;
      formRef.value?.clearValidate();
      return;
    }
    form.expectOverdueAmount = parseAmount(props.record?.expectOverdueAmount);
  },
);

function handleCancel() {
  emit('update:visible', false);
}

async function handleSave() {
  try {
    await formRef.value?.validate();
  } catch {
    return Promise.reject();
  }

  const lDate = (props.record?.lDate || '').trim();
  const sapCustomerCode = (props.record?.customerCode || '').trim();
  if (!lDate || !sapCustomerCode) {
    message.error('缺少日期或客户编码，无法保存');
    return Promise.reject();
  }
  if (form.expectOverdueAmount == null || Number.isNaN(form.expectOverdueAmount)) {
    message.error('请输入预计逾期金额');
    return Promise.reject();
  }

  submitting.value = true;
  try {
    await saveExpectOverdueAmount({
      lDate,
      sapCustomerCode,
      expectOverdueAmount: form.expectOverdueAmount,
    });
    message.success('保存成功');
    emit('update:visible', false);
    emit('submitted');
  } catch (error) {
    message.error(error instanceof Error ? error.message : '保存失败');
    return Promise.reject();
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: __props.visible,
    title: "编辑预计逾期金额",
    width: 800,
    "confirm-loading": submitting.value,
    "mask-closable": false,
    "destroy-on-close": "",
    "wrap-class-name": "edit-expect-amount-dialog-modal",
    "ok-text": "保存",
    "cancel-text": "取消",
    onOk: handleSave,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(__props.record?.lDate || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(__props.record?.customerCode || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", {
                class: "info-value",
                title: __props.record?.customerName || '-'
              }, _toDisplayString(__props.record?.customerName || '-'), 9, _hoisted_12)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(displayAmount(__props.record?.receivableBalance)), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, _toDisplayString(displayAmount(__props.record?.creditWithin)), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, _toDisplayString(displayAmount(__props.record?.overdueAmt)), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, _toDisplayString(displayAmount(__props.record?.monthEndDueAmt)), 1)
            ])
          ])
        ]),
        _createVNode(_component_a_form, {
          ref_key: "formRef",
          ref: formRef,
          layout: "vertical",
          model: form,
          rules: formRules,
          class: "edit-expect-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "预计逾期金额",
              name: "expectOverdueAmount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: form.expectOverdueAmount,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.expectOverdueAmount) = $event)),
                  precision: 2,
                  step: 0.01,
                  style: {"width":"100%"},
                  placeholder: "请输入预计逾期金额"
                }, null, 8, ["value", "step"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})